import moment from 'moment';
import commonBaseService from "../../services/commonBaseService";
import {get, map} from "lodash-es";
import {isEmptyOrUndefined} from "../common/validators";
import {SCRIP_DETAIL_STRING} from "../../strings/scripDetail/scripDetail";

export const formatAnnualReportData = (list = []) => {
    const annualReportData = list?.map((annualDataItem, idx) => {
        let currentYear = annualDataItem?.CurrentYear;
        let year1 = annualDataItem?.Year1 || annualDataItem?.YOY_1;

        if (idx === 0) {
            if (!commonBaseService.isEmptyOrUndefined(currentYear) && currentYear !== '-') {
                currentYear = moment(currentYear).format('MMM YYYY');
                currentYear = `${currentYear}(Cr)`;
            }
            if (!commonBaseService.isEmptyOrUndefined(year1) && year1 !== '-') {
                year1 = moment(year1).format('MMM YYYY');
                year1 = `${year1}(Cr)`;
            }
        }
        const rowData = {};
        const ColumnName = annualDataItem?.ColumnName;
        rowData.ColumnName = ColumnName;
        if (!commonBaseService.isEmptyOrUndefined(currentYear) && currentYear !== '-') {
            rowData.currentYear = currentYear;
        }
        if (!commonBaseService.isEmptyOrUndefined(year1) && year1 !== '-') {
            rowData.year1 = year1;
        }
        return rowData;
    });
    return annualReportData;
};

export const getCellHorizontalAlignment = (index, rowLength) => {
    if (index === 0) {
        return 'flex-start';
    } else {
        return 'flex-end';
    }
};

export const FORMAT_FINCIAL_RATIO = (tabelData = []) => {
    const STRINGS = SCRIP_DETAIL_STRING.FUNDAMENTALS.FINICIAL_RATIOS;
    const TableRowMapper = {
        [STRINGS.YEAR]: 'Year',
        [STRINGS.EPS]: 'EPS',
        [STRINGS.PE]: 'PE',
        [STRINGS.PEG]: 'PEG',
        [STRINGS.DIVIDEND_YIELD]: 'DividendYield',
        [STRINGS.CURRENT_RATIO]: 'CurrentRatio',
        [STRINGS.DEBT_EQUITY_RATIO]: 'DebtEquityRatio',
        [STRINGS.EBTIDA_GROWTH]: 'EbitdaGrowth',
        [STRINGS.PAT_GROWTH]: 'PatGrowth',
        [STRINGS.NET_SALES_GROWTH]: 'NetSalesGrowth',
        [STRINGS.QUICK_RATIO]: 'QuickRatio',
    };

    const PercentageValueRow = [
        STRINGS.DIVIDEND_YIELD,
        STRINGS.DEBT_EQUITY_RATIO,
        STRINGS.EBTIDA_GROWTH,
        STRINGS.PAT_GROWTH,
        STRINGS.NET_SALES_GROWTH,
    ];
    const currentYearData = get(tabelData, '0', {});
    const prevYearData = get(tabelData, '1', {});

    const formatedTableData = map(Object.keys(TableRowMapper), (item, index) => {
        const id = TableRowMapper[item];
        const testId = id.toLowerCase();
        const percentSuffix = PercentageValueRow.includes(item) ? `${item}%` : '';
        let currentYearValue = get(currentYearData, `${id}`, '');
        let prevYearValue = get(prevYearData, `${id}`, '');

        if (item === STRINGS.YEAR) {
            let columnTempArray = [];
            columnTempArray.push({ value: '', dataAid: `${testId}Key` });
            if (!isEmptyOrUndefined(currentYearValue)) {
                currentYearValue = moment(currentYearValue).format('MMM YYYY');
                columnTempArray.push({ value: currentYearValue, dataAid: `title1` });
            }
            if (!isEmptyOrUndefined(prevYearValue)) {
                prevYearValue = moment(prevYearValue).format('MMM YYYY');
                columnTempArray.push({ value: prevYearValue, dataAid: `title2` });
            }
            return columnTempArray;
        }
        const rowTempArray = [];

        rowTempArray.push({ value: item, dataAid: `${testId}Key` });
        if (!isEmptyOrUndefined(currentYearValue)) {
            let valueToBePushedCurrent = percentSuffix ? `${currentYearValue}%` : currentYearValue;
            rowTempArray.push({ value: valueToBePushedCurrent, dataAid: `${testId}Value1` });
        }
        if (!isEmptyOrUndefined(prevYearValue)) {
            let valueToBePushedPrevious = percentSuffix ? `${prevYearValue}%` : prevYearValue;
            rowTempArray.push({ value: valueToBePushedPrevious, dataAid: `${testId}Value2` });
        }

        return rowTempArray;
    });

    return formatedTableData;
};
export const ANNUAL_REPORT_OPTIONS = [
    { label: 'Standalone', value: 'standalone', labelDataAid: 'standalone', checkBoxDataAid: 'standalone' },
    { label: 'Consolidated', value: 'consolidated', labelDataAid: 'consolidated', checkBoxDataAid: 'consolidated' },
];
export const ANNUAL_REPORT_TYPES = [
    { label: 'Profit & loss', value: 'profitLoss', dataAid: 'profit&Loss' },
    { label: 'Balance sheet', value: 'balanceSheet', dataAid: 'balanceSheet' },
    { label: 'Results', value: 'results', dataAid: 'results' },
];

export const TREND_ANALYSIS_DATA = [
    {
        label: 'Net Revenue',
        value: 'Revenue',
    },
    {
        label: 'EBIT',
        value: 'EBIT',
    },
    {
        label: 'EBITDA',
        value: 'EBITDA',
    },
    {
        label: 'Net Profit',
        value: 'Netprofit',
    },
];

export const TREND_ANALYSIS_LEGEND_MAPPER = {
    Revenue: 'Gross profit margin',
    EBIT: 'Ebit margin',
    EBITDA: 'Ebitda margin',
    Netprofit: 'Net profit margin',
};
